import { render } from "./TheC01ItemInfo.vue?vue&type=template&id=0bedb1b0&scoped=true&ts=true"
import script from "./TheC01ItemInfo.vue?vue&type=script&lang=ts"
export * from "./TheC01ItemInfo.vue?vue&type=script&lang=ts"

import "./TheC01ItemInfo.vue?vue&type=style&index=0&id=0bedb1b0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bedb1b0"]])

export default __exports__